import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { TreeViewModule } from '@progress/kendo-angular-treeview';
import { SharedModule } from '../../shared/shared.module';
import { UsersService } from '../user/service/users.service';
import { CustomerNewUserComponent } from './components/customer-new-user/customer-new-user.component';
import { CustomerUserComponent } from './components/customer-user/customer-user.component';
import { CustomerUserRoutingModule } from './customer-user-routing.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    InputsModule,
    CustomerUserRoutingModule,
    TreeViewModule
  ],
  providers: [UsersService],
  declarations: [CustomerUserComponent, CustomerNewUserComponent],
  exports: [CustomerUserComponent],
  entryComponents: [CustomerUserComponent]
})
export class CustomerUserModule {}
